module.exports = __webpack_public_path__ + "img/official.9fbcc728.png";